define((require) => {
    "use strict";

    const Backbone = require("backbone");

    /**
     * The animation model.
     *
     * @class AnimationModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            delay: 1000,
            duration: 1000,
            easing: "linear"
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/AnimationModel.js